import { Button } from "./ui/button";
import { Calendar, Calculator } from "lucide-react";

interface CTASectionProps {
  variant?: "default" | "compact";
}

const CTASection = ({ variant = "default" }: CTASectionProps) => {
  if (variant === "compact") {
    return (
      <div className="text-center py-8 my-8 border-y border-[hsl(var(--line))]">
        <Button
          asChild
          size="lg"
          className="bg-primary text-primary-foreground hover:bg-primary/90 hover:scale-105 font-extrabold rounded-xl px-8 py-6 text-lg shadow-[0_0_30px_rgba(0,255,200,0.5)] hover:shadow-[0_0_40px_rgba(0,255,200,0.7)] transition-all duration-300"
        >
          <a href="https://api.leadconnectorhq.com/widget/bookings/neilaipudurobotics" target="_blank" rel="noopener noreferrer">
            📅 Book a Free AI Strategy Session
          </a>
        </Button>
      </div>
    );
  }

  return (
    <div className="text-center py-12 my-12 rounded-2xl glass-effect border border-[hsl(var(--line))]">
      <h3 className="font-orbitron font-bold text-2xl md:text-3xl mb-4 text-foreground">
        Ready to <span className="text-primary">Automate Your Business</span>?
      </h3>
      <p className="text-muted-foreground mb-6 max-w-2xl mx-auto">
        Join 100+ businesses that have transformed their operations with Neil AI
      </p>
      <div className="flex gap-4 justify-center flex-wrap">
        <Button
          asChild
          size="lg"
          className="bg-primary text-primary-foreground hover:bg-primary/90 hover:scale-105 font-extrabold rounded-xl px-8 py-6 text-lg shadow-[0_0_30px_rgba(0,255,200,0.5)] hover:shadow-[0_0_40px_rgba(0,255,200,0.7)] transition-all duration-300"
        >
          <a href="https://api.leadconnectorhq.com/widget/bookings/neilaipudurobotics" target="_blank" rel="noopener noreferrer">
            <Calendar className="mr-2 w-5 h-5" />
            Book a Free AI Strategy Session
          </a>
        </Button>
        <Button
          asChild
          variant="outline"
          size="lg"
          className="border-2 border-primary/30 hover:bg-primary/10 hover:border-primary/60 font-bold rounded-xl px-8 py-6 text-lg"
        >
          <a href="#neil-roi">
            <Calculator className="mr-2 w-5 h-5" />
            Calculate Your ROI
          </a>
        </Button>
      </div>
    </div>
  );
};

export default CTASection;
